import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { Subject } from 'rxjs';
import { ExcelexportService } from '../excelexport.service';

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent implements OnInit {

  inmuebles: any[] = [];
  tipo;
  btnpulse: string;
  error_name: any = [
    { name: 'geolocalizacion', value: 'Sin geolocalizacion', activo: 1 },
    { name: 'metros', value: 'Sin Metros Cuadrados', activo: 0 },
    { name: 'precio', value: 'Sin Precio', activo: 0 },
    { name: 'habitaciones', value: 'Sin habitaciones', activo: 0 },
    { name: 'tipoplanta', value: 'Sin Tipo Planta', activo: 0 },
    { name: 'usuarios', value: 'Sin Usuario asignado', activo: 0 },
    { name: 'vendidos', value: 'Pisos vendidos', activo: 0 }
  ];

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(public rest: RestService, private excel: ExcelexportService) { }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_',
        info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      },
      responsive: true,
      scrollX: true,
    };
    this.getLocationInit('metros', {});
  }

  getLocationInit(value, err) {
    this.rest.getErrors(value, this.tipo).subscribe((data) => {
      this.inmuebles = data['data'];
      this.dtTrigger.next();
    });
  }

  getLocation(value, err) {
    this.btnpulse = err.value;

    const destroy = new Promise(
      (resolve, reject) => {
        this.dtTrigger.unsubscribe();
        resolve();
      }
    );
    // Client REST Api
    this.rest.getErrors(value,this.tipo).subscribe( (data) => {


        destroy.then((then) => {
          this.inmuebles = data['data'];
          this.dtTrigger.next();
        });
      });
  }

  exportAsXLSX(): void {
    this.excel.export2DT(this.inmuebles, 'Clientes Parking');
  }





}
